import { AddMode } from '../types';
import { useTranslation } from 'react-i18next';

interface TimelineFloatingToolbarProps {
  addMode: AddMode;
  handleAddModeClick: (mode: Exclude<AddMode, 'none'>) => void;
}

const toolButtonStyle = (active: boolean) => ({
  backgroundColor: active ? 'var(--color-accent)' : 'transparent',
  color: active ? 'var(--color-accent-fg)' : 'var(--color-text-secondary)',
  fontWeight: active ? 500 : 400,
} as const);

export const TimelineFloatingToolbar = ({
  addMode,
  handleAddModeClick,
}: TimelineFloatingToolbarProps) => {
  const { t } = useTranslation('timeline');

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center pb-5"
    >
      <div
        className="pointer-events-auto flex items-center gap-1 rounded-xl px-1.5 py-1.5 shadow-lg"
        style={{
          backgroundColor: 'var(--color-bg-surface)',
          border: '1px solid var(--color-border)',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.3)',
        }}
      >
        <button
          type="button"
          data-testid="timeline-add-mode-duration"
          className="flex items-center gap-1.5 rounded-lg px-3.5 py-2 text-xs transition-colors"
          style={toolButtonStyle(addMode === 'duration')}
          onMouseEnter={(e) => {
            if (addMode !== 'duration') {
              e.currentTarget.style.backgroundColor = 'var(--color-bg-hover)';
            }
          }}
          onMouseLeave={(e) => {
            if (addMode !== 'duration') {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
          onClick={() => handleAddModeClick('duration')}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <line x1="5" y1="9" x2="5" y2="15" />
            <line x1="19" y1="9" x2="19" y2="15" />
          </svg>
          {t('toolbar.duration')}
        </button>

        <div className="h-5 w-px" style={{ backgroundColor: 'var(--color-border)' }} />

        <button
          type="button"
          data-testid="timeline-add-mode-milestone"
          className="flex items-center gap-1.5 rounded-lg px-3.5 py-2 text-xs transition-colors"
          style={toolButtonStyle(addMode === 'milestone')}
          onMouseEnter={(e) => {
            if (addMode !== 'milestone') {
              e.currentTarget.style.backgroundColor = 'var(--color-bg-hover)';
            }
          }}
          onMouseLeave={(e) => {
            if (addMode !== 'milestone') {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
          onClick={() => handleAddModeClick('milestone')}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <circle cx="12" cy="12" r="3" />
          </svg>
          {t('toolbar.milestone')}
        </button>
      </div>
    </div>
  );
};
